// Loaded from CDN and included in externals in webpack.config.js
import MathJax from "mathjax";

// Required JS from local files
import {
  addInitialFunction,
  Context,
  dfmAlert,
  dfmAlertInverted,
  isParent,
  isStudent,
  isTeacher,
  isTrustAdmin,
  limitLength,
  liveGameDialog,
  numberWithCommas,
  nth,
  redirectToRequiredLogin,
  setTaskDialog,
  startPracticeDialog,
  timeSince
} from "./dfm5";
import { posthogEventCoursesHomeClicked, posthogEventCourseViewed } from "~/utils/posthog/courses";
import {
   posthogEventRevisionHubLinkClicked,
   posthogEventSetATaskModalOpened,
   posthogEventStartAPracticeModalOpened
} from "~/utils/posthog/tasks";
import { removeQueryParams } from "~/utils/urls";

// CSS
import "./dashboard.css";

$(document).ready(function(){
   $("#dashboard-main-progress-tabs").dfmTabs();
   $("#dashboard-training").click(function(){
      window.location = 'training.php';
   });
   $("#dashboard-button-myworksheets").click(function(){
      window.location = '/worksheets.php?wdid=home';
   });
   $("#dashboard-main-progress-buttons button").click(function(){
      window.location = '/progress.php';
   });

   addInitialFunction(redirectToRequiredLogin);
   addInitialFunction(personaliseDashboard);
   addInitialFunction(loadNotifications);
   addInitialFunction(loadDashboardData);
   addInitialFunction(displayCoursesLinks);

   // Set up revision hub notices and links, with Posthog events.
   addInitialFunction(() => {
      const $teacherRevisionHubNotice = $("#dashboard-revision-hub-teacher-notice");
      const $studentRevisionHubNotice = $("#dashboard-revision-hub-student-notice");

      // If the user is a student, see if we have a revision hub link in local storage.
      const revisionHubLink = isStudent() && localStorage.getItem(`dfRevisionHubLink_${Context.user.uid}`);
      if (revisionHubLink) {
         // Update the notice with the context that the student has been using the revision hub.
         $studentRevisionHubNotice.find(".dashboard__notice__title").text("Keep Up the Momentum! Sharpen Your GCSE Skills.");
         $studentRevisionHubNotice.find(".dashboard__notice__message").text("Keep going! Track your progress and tackle more past papers to stay ahead in your revision.");
         $studentRevisionHubNotice.find(".dashboard__notice__button").text("Continue GCSE Revision");
         // Use the user's tailored revision hub link.
         $studentRevisionHubNotice.find(".dashboard__notice__button-bar a").attr("href", revisionHubLink);
      }

      // Posthog events for the notice links.
      $studentRevisionHubNotice.find(".dashboard__notice__button").on("click", () => {
         posthogEventRevisionHubLinkClicked({
            triggerId: "dashboard-revision-hub-student-notice-button",
            linkUrl: revisionHubLink ?? "/revision/papers",
         });
      });
      $teacherRevisionHubNotice.find(".dashboard__notice__button").on("click", () => {
         posthogEventRevisionHubLinkClicked({
            triggerId: "dashboard-revision-hub-teacher-notice-button",
            linkUrl: "/revision/papers",
         });
      });
   });

   $("#dashboard-trophies a").click(displayTrophies);
   $("#dashboard-button-settask").on("click", () => {
      posthogEventSetATaskModalOpened({ triggerId: "dashboard-set-a-task-button" });
      setTaskDialog();
   });
   $("#dashboard-links-questionspastpapers").click(questionsPastPapersDialog);
   $("#dashboard-practicebutton").on("click", () => {
      posthogEventStartAPracticeModalOpened({ triggerId: "dashboard-start-a-practice-button" });
      startPracticeDialog();
   });
   $("#dashboard-links-livegame").click(liveGameDialog);


   // Display a confirmation of joining a class, or an error message on failure.
   // @TODO: We should probably pass an ID instead, and check in the backend that this student is in
   // fact a member of this class before displaying it, but that's additional processing that we can
   // bypass for now -- plus we're replacing this whole arrangement in the near-mid future.
   // (No risk anyway, other than making the site display some hilarious things in an alert.)
   const urlParams = new URLSearchParams(window.location.search);
   const joinedClass = urlParams.get('joinedClass');
   const joinedClassError = urlParams.get('joinedClassError');
   if (joinedClass && !joinedClassError) {
      dfmAlert(`You have been added to <strong>${joinedClass}</strong>`);
   } else if (joinedClassError === 'NOT_A_STUDENT') {
      dfmAlert(`Only students can be added to classes.`);
   } else if (joinedClassError === 'ALREADY_IN_CLASS') {
      dfmAlert(`You are already a member of ${joinedClass ?? 'the class'}.`);
   } else if (joinedClassError) {
      dfmAlert(`An unknown error occurred when adding you to the class.`);
   }
   // Remove these consumed params from the current URL
   removeQueryParams('joinedClass', 'joinedClassError');
});

function displayCoursesLinks() {
   $("#dashboard-setup-courses").show();
   $("#dashboard-setup-courses").on("click", function() {
      posthogEventCoursesHomeClicked({
         triggerId: "dashboard-courses-link",
      });
   });
}

function personaliseDashboard() {
   $(".teacher").hide();
   $(".student").hide();
   $(".trust").hide();
   $(".parent").hide();
   if(isTeacher())$(".teacher").show();
   else if(isStudent())$(".student").show();
   else if(isTrustAdmin())$(".trust").show();
   else if(isParent())$(".parent").show();
}

function questionsPastPapersDialog() {
   dfmAlertInverted(""
       +"<div class='dialog-options'><h1>Select an option</h1>"
       +"<div><button id='settask-bytopic'>By Topic</button><p>Explore questions and video content by topic, with options to browse questions, or set questions by topic.</p></div>"
       +"<div><button id='settask-pastpapers'>Past Papers</button><p>View papers from a variety of exam boards, with options to set papers as a task to students.</p></div>"
       +"</div>");
   $("#settask-bytopic").click(function(){
      window.location = "/explorer.php";
   });
   $("#settask-pastpapers").click(function(){
      window.location = "/worksheets.php?wdid=2";
   });
}


function loadNotifications() {
  if (!Context.user || Context.user.type === "trust") {
    return false;
  }

  let url = "/api/notifications/dashboard";

  $.ajax({
    type: "GET",
    url: url,
    contentType: false,
    processData: false,
    cache: false,
    dataType: "json",
    success: function (data) {
      var notifications = data.notifications;
      var ul = $("#dashboard-notifications");
      if (notifications.length === 0) {
        var welcomeTxt;
        if (isStudent()) {
          welcomeTxt = "<strong>Welcome to DrFrostMaths!</strong> This is your home dashboard, where you can start a practice, see what work has been assigned to you by a teacher, explore a course, and more. <br>We're keen to help you whatever your maths goals are.";
        } else if (isParent()) {
          welcomeTxt = "<strong>Welcome to DrFrostMaths!</strong> This is your home dashboard, where you can access all the key functionality of the site, including setting and monitoring work to your children, and getting an overview of what they're doing.<br>We haven't quite finished Parent accounts yet. For the moment, go to <strong>Add/Manage Children</strong> to add accounts; they'll be able to use these accounts to practice but you can't yet set work. We'll be finishing this shortly.";
        } else {
          welcomeTxt = "<strong>Welcome to DrFrostMaths!</strong> This is your home dashboard, where you can access all the key functionality of the site, including setting and monitoring work, and getting an overview of your students.<br>If you're new to us, we recommend using the Help & Training button above to see a guide to getting started. Or if you want to first have a play, start with the <em>Question Explorer</em>.";

        }
        notifications.push({ icon: "/images/wave_icon.svg", text: welcomeTxt, url: "explorer.php" });
      }
      $.each(notifications, function (k, n) {
          const li = document.createElement("li");
          li.setAttribute("id", `notification-${n.nid}`);
          ul.append(li);

          // Ticket 250: We wrap the content within an <a> only if we have a URL to link to. Otherwise, we wrap within a
          //   <span> (used only for styling purposes else we'd append straight to the <li>)
          let container;
          if (n.url) {
              const a = document.createElement("a");
              a.setAttribute("href", n.url);
              li.append(a);
              container = $(a);
          }
          else {
              const span = document.createElement("span");
              span.setAttribute("class", "notif-outer");
              li.append(span);
              container = $(span);
          }

          container.append(`<img src="${n.icon}">`);
          container.append(`<h2>${n.text}</h2>`);
          container.append(`<h4>${timeSince(n.time)}</h4>`);
          if (n.subtext) {
              container.append(`<h3>${limitLength(n.subtext, 200)}</h3>`);
          }
      });
      ul.find(".accuracy").each(function () {
        $(this).dfmAccuracyBar();
        // Move to start of notification text so that it 'floats' on the right properly.
        var parent = $(this).parent();
        $(this).detach();
        parent.prepend($(this));
      });
      MathJax.typeset();

    },
    error: function (jqXHR, textStatus, errorThrown) {
      dfmAlert("There was an error obtaining the dashboard notifications:<br><br><strong>" + jqXHR.responseText + "</strong>");
    }
  });
}

const ENGAGEMENT_COLOURS = [];

function loadDashboardData() {
   var url = "/api/user/current/dashboard";
   console.log(url);
   $.ajax({
      type: "GET",
      url: url,
      contentType:false,
      processData: false,
      cache: false,
      dataType: "json",
      success: function(data)
      {
         console.log(JSON.stringify(data));
         $("#dashboard-header-titles h1").html(data.name);
         $("#dashboard-header-titles h2").html(isParent() ? "Parent/Guardian" : data.org);
         $("#dashboard-header-logo").attr('src', data.logo ? data.logo : "/images/user_icon.svg");
         if(isTeacher()) {
            $("#dashboard-main-left").addClass('teacher-layout');
            $("#dashboard-schoolrank").html(data.rank+"<sup>"+nth(data.rank)+"</sup>");
            $("#dashboard-schoolpoints").html(numberWithCommas(data.points));

            $("#dashboard-schoolengagementscore").empty();
            $("#dashboard-schoolengagementscore").html(data.engagementscore+"/6").addClass('engagementscore-'+data.engagementscore);
            $("#dashboard-school-engagementscore").on("click", function(){
               window.location = 'schoolsanalysis-map.php';
            });

            var ul = $("#dashboard-main-work-latest ul").empty();
            if(data.latesttasks.length>0) {

               $.each(data.latesttasks, function(k, task) {
                  var dueDateStr = task.duedate ? "Due "+timeSince(task.duedate) : "No due date";
                  ul.append("<li id='dashboard-task-"+task.aid+"'><a href='#'>"
                    +"<span class='completed'><img src='images/tick_icon.svg'><label>"+task.numcompleted+"/"+task.numoutof+"</label></span>"
                    +(task.accuracy ? "<span class='accuracy'>"+task.accuracy+"</span>" : "")
                    + "<h2>" + (task.text ? limitLength(task.text, 150) : "-") + "</h2>"
                    + "<h3>" + (task.settocache ? limitLength(task.settocache, 200) : "-") + ", " + dueDateStr + "</h3>"
                    +"</a></li>");
                  $("#dashboard-task-"+task.aid).data('aid', task.aid);
                  $("#dashboard-task-"+task.aid).click(function() {
                     var aid = $(this).data('aid');
                     window.location = 'progress.php?aid='+aid;
                  });
                  if(task.accuracy)$("#dashboard-task-"+task.aid).find('.accuracy').dfmAccuracyBar();
               });

            } else {
               ul.append("<li>No tasks have been set. Use the <strong>Set a Task</strong> button below.</li>");
            }

            $("#dashboard-weeklystats-tasksset").html(data.weeklystats.tasksset);
            $("#dashboard-weeklystats-totalqs").html(data.weeklystats.totalqs);
            $("#dashboard-weeklystats-totalindependentqs").html(data.weeklystats.totalindependentqs);

            $("#progresstabs-topstudents tbody").empty();
            if(data.weeklystats.topscorers)$.each(data.weeklystats.topscorers, function(k,topscorer) {
               $("#progresstabs-topstudents tbody").append("<tr><td>"+topscorer.firstname+" "+topscorer.surname+(topscorer.ctext ? "<br><small>"+topscorer.ctext+"</small>" : "")+"</td><td><strong>"+Math.round(topscorer.totalpoints)+"</td></tr>");
            });
            if(!data.weeklystats.topscorers)$("#progresstabs-topstudents tbody").append("<tr><td>No student data.</td></tr>");

           if (isTeacher() && data.expiring) {
               dfmAlertInverted("<h2>Your school subscription is expiring in less than four weeks</h2>"
                  +"<p>Schools must go through a subscription process to use teacher functionality. Subscription fees allow us to continue operating as a charity.</p><p>After this time, student accounts will be unaffected, but all but the most recently logged-in teacher account will be put in a dormant state, and you will be limited to <b>three</b> classes.</p>"
                  +"<p><a style='color:white' href='settings.php?tab=subscription'>Click here to update your subscription and read further.</a></p>");
            }
         }
         else if (isStudent()) {
            $("#dashboard-main-left").addClass('student-layout');
            $("#dashboard-trophies label").html(data.trophies+"/"+data.max_trophies);
            // $("#dashboard-mastered label").html(data.mastered+"/"+data.mastered_max);
            $(".dashboard-mastery").each(function(){
               $(this).dfmMasteryBar();
            });
            for(var i=1; i<=3; i++)$("#dashboard-mastered label").eq(i-1).html(data.mastery[i]);

            $("#dashboard-studentpoints").html(Math.round(data.points));
            $.each(data.latesttasks, function(k, task) {
               var dueDateStr = task.duedate ? "Due "+timeSince(task.duedate) : "";
               $("#dashboard-homework ul").append("<li id='dashboard-task-"+task.aid+"'><a href='#'>"
                 +"<img src='images/"+(task.numcompleted ? "tick" : "cross")+"_icon.svg'>"
                 +(task.accuracy && task.numcompleted ? "<span class='accuracy'>"+task.accuracy+"</span>" : "")
                 +"<h2></h2>"
                 +"<h3>"+dueDateStr+"</h3>"
                 +"</a></li>");
               $("#dashboard-task-"+task.aid).find('h2').html(task.text ? limitLength(task.text, 150) : "-");
               $("#dashboard-task-"+task.aid).data('aid', task.aid);
               $("#dashboard-task-"+task.aid).click(function() {
                  var aid = $(this).data('aid');
                  window.location = `progress.php?aid=${aid}&from=dashboard-task-list`;
               });
            });

            if (data.latesttasks.length == 0) {
              $("#dashboard-homework ul").append("<li>You haven't been set any tasks.</li>");
            }

            $("#dashboard-whattoworkon-skills ul").empty();
            $.each(data.recommendedskills, function(k, sk) {
               $("#dashboard-whattoworkon-skills ul").append("<li><a href='explorer.php?skid="+sk.skill.skid+"'><span class='mastery'>"+(sk.mastery ? sk.mastery : 0)+"</span> <em>"+sk.skill.publicid+"</em> "+sk.skill.name+"</a></li>");
            });
            $("#dashboard-whattoworkon-skills .mastery").each(function() {
               $(this).dfmMasteryBar();
            });
            $("#dashboard-homework .accuracy").each(function(){
               $(this).dfmAccuracyBar();
            });

            $("#dashboard-whattoworkon-courses ul").empty();
            const courses = data.courses ?? [];
            const coids = [];
            $.each(courses, function(k,course) {
               const courseAlreadyRendered = coids.includes(course.coid);
               if (!courseAlreadyRendered) {
                  const courseName = course.authorName ? `[${course.authorName}] ${course.name}` : course.name;
                  const coid = course.coid;
                  const href = `/explorer.php?coid=${coid}`;
                  $("#dashboard-whattoworkon-courses ul").append(`<li><a id="course-link-${coid}" href="${href}">${courseName}</a></li>`);
                  $(`#course-link-${coid}`).on("click", function(e) {
                     e.preventDefault();
                     posthogEventCourseViewed({
                        triggerId: "dashboard-course-link",
                        course,
                     });
                     window.location = href;
                  });
               }
               coids.push(course.coid);
            });
            // Hide the courses container if there are no assigned courses.
            $("#dashboard-whattoworkon-courses").toggle(courses.length > 0);
         }
         else if(isTrustAdmin()) {
            $.each(data.trust._schools, function(k,school) {
               $("#dashboard-main-trustschools tbody").append("<tr><td><img src='"+school.thumb+"'></td><td>"+school.name+"</td><td><span class='engagementscore-"+school.engagementscore+"'>"+school.engagementscore+"/6</span></td><td><select id='dashboard-trustschool-"+school.sid+"'></select></td></tr>");
               $("#dashboard-trustschool-"+school.sid).actionMenu({
                  default: "Action",
                  options: []
               });

            });
            $("#dashboard-trustpoints").html(numberWithCommas(data.points));
         }
         else if(isParent()) {
            if(data.latesttask) {
               $("#dashboard-main-work-latest-info span").html(limitLength(data.latesttask.taskname, 100));
               $("#dashboard-main-work-latest-completed span").html(data.latesttask.completed+"/"+data.latesttask.outof);
            } else {
               $("#dashboard-main-work-latest-info span").html("No tasks set.");
               $("#dashboard-main-work-latest-completed").hide();
            }

            // This is messy. Same box as teacher (except different label on button) but separate HTML...
            if (data.weeklystats) {
               $("#dashboard-weeklystats-tasksset-parent").html(String(data.weeklystats.tasksset));
               $("#dashboard-weeklystats-totalqs-parent").html(data.weeklystats.totalqs);
               $("#dashboard-weeklystats-totalindependentqs-parent").html(data.weeklystats.totalindependentqs);
            }
         }

         MathJax.typeset();
      },
      error: function(jqXHR, textStatus, errorThrown){
         dfmAlert("There was an error obtaining the dashboard data:<br><br><strong>"+jqXHR.responseText+"</strong>");
      }
   });

}


function displayTrophies() {
   $.ajax({
      type: "GET",
      url: "/api/user/current/trophies",
      contentType: false,
      processData: false,
      cache: false,
      dataType: "json",
      success: function(data) {
         dfmAlert("<ul id='trophy-list'></ul>");
         data.trophies.forEach((trophy) => {
            $("#trophy-list").append("<li "+(trophy.earned ? "" : "class='notearned'")+"><img src='images/trophy_icon.svg'><h1><span class='"+trophy.medal+"'>"+trophy.medal+"</span> "+trophy.name+"</h1><h2>"+trophy.description+"</h2></li>");
         });
      },
      error: function(jqXHR){
         dfmAlert("There was an error obtaining the trophy list:<br><br><strong>"+jqXHR.responseText+"</strong>");
      }
   });

}
